import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/athakai-br/htdocs/br.athakai.com/app/components/Comments.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/athakai-br/htdocs/br.athakai.com/app/components/Header.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/athakai-br/htdocs/br.athakai.com/app/components/SinglePostContent.js");
;
import(/* webpackMode: "eager" */ "/home/athakai-br/htdocs/br.athakai.com/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/athakai-br/htdocs/br.athakai.com/node_modules/next/dist/client/image-component.js");
